import { createSelector } from 'reselect';

import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectIsFidelityCardScanLoading = (state: AppStateType) => state.fidelityCard.isScanningLoading;
export const selectFidelityCardData = (state: AppStateType) => state.fidelityCard.fidelityCardData?.fidelity_card;
export const selectActiveFidelityModalCode = (state: AppStateType) => state.fidelityCard.activeFidelityModalCode;

export const selectFidelityCardId: (state) => string = createSelector([selectFidelityCardData], data => {
  return data?.card_identifier;
});
